import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, vModelSelect as _vModelSelect, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '../../../src/assets/images/app/barbas-mobile.png'
import _imports_1 from '../../../src/assets/images/app/noto_wrapped-gift.svg'


const _hoisted_1 = { class: "home__head" }
const _hoisted_2 = {
  class: "navbar navbar-expand-lg",
  style: {"position":"fixed","top":"0","width":"100%","z-index":"1000","background-color":"#fff","padding":"0","box-shadow":"0px 4px 16px 0px rgba(69, 74, 108, 0.08)"}
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "navbar-toggler",
  type: "button"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", {
  class: "navbar-nav ms-auto",
  style: {"z-index":"1000"}
}, null, -1)
const _hoisted_8 = {
  class: "visible-mobile",
  style: {"margin-top":"50px"}
}
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  key: 0,
  class: "countdown"
}
const _hoisted_11 = { class: "countdown__content" }
const _hoisted_12 = { class: "countdown__content__wpp" }
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"countdown__content__gift\"><div class=\"countdown__content__gift__text__title\"><span>Te regalamos <img src=\"" + _imports_1 + "\" alt=\"\"> tu</span></div><div class=\"countdown__content__gift__text__subtitle\"><span class=\"countdown__content__gift__text__subtitle__spanMonthFree\">2DO MES GRATIS*</span></div></div>", 1)
const _hoisted_17 = { class: "countdown__counter" }
const _hoisted_18 = { class: "countdown__counter__item1" }
const _hoisted_19 = { class: "countdown__counter__item1__element1" }
const _hoisted_20 = { class: "countdown__counter__item1__number" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "Horas", -1)
const _hoisted_22 = { class: "countdown__counter__item1__element2" }
const _hoisted_23 = { class: "countdown__counter__item1__number" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "Minutos", -1)
const _hoisted_25 = { class: "countdown__counter__item1__element3" }
const _hoisted_26 = { class: "countdown__counter__item1__number" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", null, "Segundos", -1)
const _hoisted_28 = { class: "visible-mobile" }
const _hoisted_29 = {
  key: 0,
  class: "promotion"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "*Un mes gratis por cliente, para aportes hasta S/400.", -1)
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 0,
  class: "headerInfo"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "headerInfo__content" }, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("Descubre el "),
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      alt: ""
    }),
    /*#__PURE__*/_createTextVNode(" que tenemos para ti en el paso 2 ")
  ])
], -1)
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "quote" }
const _hoisted_36 = { class: "container" }
const _hoisted_37 = { class: "row justify-content-center" }
const _hoisted_38 = { class: "col-md-10 col-sm-10 col-11" }
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "row justify-content-center" }
const _hoisted_41 = { class: "col-md-10 col-sm-10 col-11" }
const _hoisted_42 = {
  key: 0,
  class: "row justify-content-center"
}
const _hoisted_43 = { class: "col-md-3 col-sm-4 col-12" }
const _hoisted_44 = { class: "quote__stepper" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { class: "name" }
const _hoisted_47 = { class: "quote__step" }
const _hoisted_48 = ["src"]
const _hoisted_49 = {
  key: 1,
  class: "quote__step__title"
}
const _hoisted_50 = {
  key: 0,
  class: "personal-date row justify-content-center"
}
const _hoisted_51 = { class: "col-md-5 col-sm-6 col-12" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "hidden-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "headerInfo" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "headerInfo__content" }, [
      /*#__PURE__*/_createElementVNode("span", null, [
        /*#__PURE__*/_createTextVNode("Descubre el "),
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_1,
          alt: ""
        }),
        /*#__PURE__*/_createTextVNode(" que tenemos para ti en el paso 2 ")
      ])
    ])
  ])
], -1)
const _hoisted_53 = { class: "personal-date__card card card-form" }
const _hoisted_54 = { class: "card-body mt-2" }
const _hoisted_55 = { action: "" }
const _hoisted_56 = { class: "row" }
const _hoisted_57 = { class: "col-xs-12 col-md-12 col-sm-12 col-12" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu nombre", -1)
const _hoisted_60 = { class: "row" }
const _hoisted_61 = { class: "col-xs-12 col-md-6 col-sm-6 col-6" }
const _hoisted_62 = ["disabled"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu apellido paterno", -1)
const _hoisted_64 = { class: "col-xs-12 col-md-6 col-sm-6 col-6" }
const _hoisted_65 = ["disabled"]
const _hoisted_66 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu apellido materno", -1)
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-xs-12 col-md-6 col-sm-6 col-6" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { class: "col-xs-12 col-md-6 col-sm-6 col-6" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: "--",
  selected: ""
}, " Género ", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("option", { value: "M" }, "Masculino", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("option", { value: "F" }, "Femenino", -1)
const _hoisted_75 = [
  _hoisted_72,
  _hoisted_73,
  _hoisted_74
]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("small", null, "Por favor selecciona tu género", -1)
const _hoisted_77 = { class: "row" }
const _hoisted_78 = { class: "col-xs-12 col-md-6 col-sm-6 col-6" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu número de celular", -1)
const _hoisted_80 = { class: "col-xs-12 col-md-6 col-sm-6 col-6" }
const _hoisted_81 = ["disabled"]
const _hoisted_82 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu correo electrónico", -1)
const _hoisted_83 = {
  key: 0,
  class: "form-group"
}
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", {
  class: "alert text-center text-danger",
  role: "alert",
  style: {"padding":"0.71rem 1rem"}
}, " En estos momentos no contamos con un plan que se adecúe a tus necesidades. ", -1)
const _hoisted_85 = [
  _hoisted_84
]
const _hoisted_86 = { class: "form-group mt-2" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = { class: "visible-mobile" }
const _hoisted_89 = { class: "contentwpp" }
const _hoisted_90 = {
  class: "btn btn-wapp",
  target: "_blank",
  href: "tel:016149288"
}
const _hoisted_91 = ["src"]
const _hoisted_92 = /*#__PURE__*/_createElementVNode("span", null, "Quiero comunicarme con un asesor", -1)
const _hoisted_93 = { class: "row d-flex justify-content-center" }
const _hoisted_94 = { class: "programSavings pt-2 col-md-5 col-sm-5 col-12" }
const _hoisted_95 = { class: "card card-form" }
const _hoisted_96 = { class: "programSavings__card" }
const _hoisted_97 = { class: "card-body" }
const _hoisted_98 = { action: "" }
const _hoisted_99 = { class: "ahorroMes form-group" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "d-block text-center pb-2"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "¿Cuánto deseas ahorrar al mes?")
], -1)
const _hoisted_101 = { class: "amount-selector" }
const _hoisted_102 = { class: "min" }
const _hoisted_103 = { class: "min" }
const _hoisted_104 = {
  key: 0,
  class: "yearSaving form-group"
}
const _hoisted_105 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "d-block text-center mb-2"
}, [
  /*#__PURE__*/_createElementVNode("b", null, "¿Por cuántos años deseas ahorrar?")
], -1)
const _hoisted_106 = { class: "period-selector" }
const _hoisted_107 = ["id", "value", "onUpdate:modelValue", "onChange"]
const _hoisted_108 = ["for"]
const _hoisted_109 = {
  key: 1,
  class: "loader text-center"
}
const _hoisted_110 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin text-main" }, null, -1)
const _hoisted_111 = /*#__PURE__*/_createElementVNode("h4", { class: "text-second" }, "Cargando planes", -1)
const _hoisted_112 = [
  _hoisted_110,
  _hoisted_111
]
const _hoisted_113 = { key: 2 }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("h3", { class: "text-main text-center" }, " No hemos encontrado un plan para ti ", -1)
const _hoisted_115 = [
  _hoisted_114
]
const _hoisted_116 = { class: "visible-mobile" }
const _hoisted_117 = {
  key: 0,
  class: "card card-plan w-100"
}
const _hoisted_118 = { class: "card-body" }
const _hoisted_119 = { class: "card-plan__item" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("span", null, "Mi aporte total", -1)
const _hoisted_121 = { class: "card-plan__item" }
const _hoisted_122 = /*#__PURE__*/_createElementVNode("span", null, "Mi ganancia", -1)
const _hoisted_123 = { class: "card-plan__item" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("span", null, "Devolución total", -1)
const _hoisted_125 = { class: "card-footer" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode(" Mi TREA "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" con este plan es: ")
], -1)
const _hoisted_127 = { class: "interest ml-auto" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("div", { class: "programSavings__content" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "rememberme text-center mb-2 mt-4" }, " Recuerda que: "),
  /*#__PURE__*/_createElementVNode("label", {
    for: "",
    class: "d-block text-center"
  }, [
    /*#__PURE__*/_createTextVNode("Tu ahorro incluye un seguro de vida por "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" S/ 25,000 para proteger a los que más amas.")
  ])
], -1)
const _hoisted_129 = { class: "visible-mobile" }
const _hoisted_130 = { class: "btnPink row" }
const _hoisted_131 = { class: "col" }
const _hoisted_132 = { class: "text-center form-group" }
const _hoisted_133 = { class: "text-center form-group" }
const _hoisted_134 = ["src"]
const _hoisted_135 = { class: "visible-mobile" }
const _hoisted_136 = {
  key: 0,
  class: "card card-info"
}
const _hoisted_137 = { class: "rememberme card-body" }
const _hoisted_138 = { class: "visible-mobile" }
const _hoisted_139 = {
  class: "btn btn-wapp",
  target: "_blank",
  href: "tel:016149288"
}
const _hoisted_140 = ["src"]
const _hoisted_141 = /*#__PURE__*/_createElementVNode("span", null, "Quiero comunicarme con un asesor", -1)
const _hoisted_142 = { class: "Myplan pt-2 col-md-4 col-sm-4 col-12" }
const _hoisted_143 = { class: "hidden-mobile" }
const _hoisted_144 = {
  key: 0,
  class: "card card-plan"
}
const _hoisted_145 = /*#__PURE__*/_createElementVNode("h5", { class: "simulator text-center" }, "Mi plan", -1)
const _hoisted_146 = { class: "card-body" }
const _hoisted_147 = { class: "card-plan__item" }
const _hoisted_148 = /*#__PURE__*/_createElementVNode("span", null, "Mi aporte total", -1)
const _hoisted_149 = { class: "card-plan__item" }
const _hoisted_150 = /*#__PURE__*/_createElementVNode("span", null, "Mi ganancia", -1)
const _hoisted_151 = { class: "card-plan__item" }
const _hoisted_152 = /*#__PURE__*/_createElementVNode("span", null, "Devolución total", -1)
const _hoisted_153 = { class: "card-footer text-center" }
const _hoisted_154 = { class: "card-footer__interest text-center" }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("span", { class: "card-footer__text text-center d-block" }, [
  /*#__PURE__*/_createTextVNode(" Aprovecha esta SUPER tasa "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ahorrando DE A POCOS cada mes ")
], -1)
const _hoisted_156 = { class: "Pinkbtn card-button text-center form-group mt-3 mb-3" }
const _hoisted_157 = { class: "card-plan__quote-btn text-center form-group" }
const _hoisted_158 = ["src"]
const _hoisted_159 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_160 = {
  key: 0,
  class: "plan-detail"
}
const _hoisted_161 = { class: "row justify-content-center" }
const _hoisted_162 = { class: "col-md-8 col-sm-8 col-12" }
const _hoisted_163 = { class: "card" }
const _hoisted_164 = { class: "card-body" }
const _hoisted_165 = { class: "plan-detail__info duration" }
const _hoisted_166 = { class: "plan-detail__info__description" }
const _hoisted_167 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail__info__label" }, " Ahorros reales ", -1)
const _hoisted_168 = /*#__PURE__*/_createElementVNode("span", null, " + ", -1)
const _hoisted_169 = { class: "plan-detail__info total-amount" }
const _hoisted_170 = { class: "plan-detail__info__description" }
const _hoisted_171 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail__info__label" }, " Rentabilidad ", -1)
const _hoisted_172 = /*#__PURE__*/_createElementVNode("span", null, " = ", -1)
const _hoisted_173 = { class: "plan-detail__info breakdown" }
const _hoisted_174 = { class: "plan-detail__info__description" }
const _hoisted_175 = /*#__PURE__*/_createElementVNode("div", { class: "plan-detail__info__label" }, " Meta de ahorro ", -1)
const _hoisted_176 = {
  key: 1,
  class: "plan-selection"
}
const _hoisted_177 = { class: "row justify-content-center" }
const _hoisted_178 = { class: "col-md-8 col-sm-8 col-12" }
const _hoisted_179 = { class: "plan-selection__amount" }
const _hoisted_180 = { class: "label" }
const _hoisted_181 = { class: "amount" }
const _hoisted_182 = { class: "tea" }
const _hoisted_183 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_184 = { class: "plan-selection__actions" }
const _hoisted_185 = {
  key: 2,
  class: "finalstep"
}
const _hoisted_186 = { class: "row justify-content-center" }
const _hoisted_187 = /*#__PURE__*/_createElementVNode("div", { class: "hidden-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stepthree mb-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "" }, " ¡Estás a solo un paso de construir tu meta! ")
  ])
], -1)
const _hoisted_188 = { class: "col-md-12 col-sm-12 col-12 mt-2" }
const _hoisted_189 = { action: "" }
const _hoisted_190 = { class: "row justify-content-between" }
const _hoisted_191 = { class: "visible-mobile" }
const _hoisted_192 = { class: "col-md-6 col-12" }
const _hoisted_193 = { class: "summary" }
const _hoisted_194 = { class: "summary__section" }
const _hoisted_195 = { class: "summary__section__label text-main mb-2" }
const _hoisted_196 = { key: 0 }
const _hoisted_197 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-chevron-down" }, null, -1)
const _hoisted_198 = [
  _hoisted_197
]
const _hoisted_199 = { key: 1 }
const _hoisted_200 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-up",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_201 = [
  _hoisted_200
]
const _hoisted_202 = { class: "summary__section__detail" }
const _hoisted_203 = /*#__PURE__*/_createElementVNode("span", null, "Pago mensual:", -1)
const _hoisted_204 = { class: "summary__section__detail" }
const _hoisted_205 = /*#__PURE__*/_createElementVNode("span", null, "Período:", -1)
const _hoisted_206 = { key: 0 }
const _hoisted_207 = { class: "summary__section__detail" }
const _hoisted_208 = /*#__PURE__*/_createElementVNode("span", null, "Tu 2da fecha de pago:", -1)
const _hoisted_209 = { class: "summary__section__detail" }
const _hoisted_210 = /*#__PURE__*/_createElementVNode("span", null, "Ganancia:", -1)
const _hoisted_211 = { class: "summary__section__detail" }
const _hoisted_212 = /*#__PURE__*/_createElementVNode("span", null, "Monto de cobertura:", -1)
const _hoisted_213 = /*#__PURE__*/_createElementVNode("div", { class: "summary__section__infouser mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Datos del Titular")
], -1)
const _hoisted_214 = { class: "summary__section__detail" }
const _hoisted_215 = { class: "text-upper text-uppercase" }
const _hoisted_216 = { class: "summary__section__detail" }
const _hoisted_217 = /*#__PURE__*/_createElementVNode("span", null, "Nombre:", -1)
const _hoisted_218 = { class: "summary__section__detail" }
const _hoisted_219 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_220 = { class: "summary__section__detail" }
const _hoisted_221 = /*#__PURE__*/_createElementVNode("span", null, "Fecha de Nacimiento:", -1)
const _hoisted_222 = { class: "summary__section__detail" }
const _hoisted_223 = /*#__PURE__*/_createElementVNode("span", null, "Género:", -1)
const _hoisted_224 = { key: 0 }
const _hoisted_225 = { key: 1 }
const _hoisted_226 = { class: "summary__section__detail" }
const _hoisted_227 = /*#__PURE__*/_createElementVNode("span", null, "Celular:", -1)
const _hoisted_228 = { class: "summary__section__detail" }
const _hoisted_229 = /*#__PURE__*/_createElementVNode("span", null, "Correo:", -1)
const _hoisted_230 = /*#__PURE__*/_createStaticVNode("<div class=\"summary__info\"><div class=\"summary__section__detail\"><span class=\"txt w-100 text-center\"> Enviaremos el contrato a tu correo con esta información detallada. </span></div><div class=\"summary__section__detail\"><small class=\"text-center d-block mb-2\"><span>Puedes modificar los beneficiarios de tu seguro de vida enviando un correo a </span><a href=\"mailto:rumbo@interseguro.com.pe\">rumbo@interseguro.com.pe</a></small></div></div>", 1)
const _hoisted_231 = { class: "titular-dates col-md-6 col-12" }
const _hoisted_232 = { class: "titular-dates__form card card-form" }
const _hoisted_233 = /*#__PURE__*/_createElementVNode("div", { class: "card__title text-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Datos del Titular")
], -1)
const _hoisted_234 = { class: "card-body" }
const _hoisted_235 = { class: "cardPay" }
const _hoisted_236 = { action: "" }
const _hoisted_237 = { class: "formUser row" }
const _hoisted_238 = { class: "col-md-12 col-sm-12 col-12" }
const _hoisted_239 = { class: "form-group" }
const _hoisted_240 = ["disabled"]
const _hoisted_241 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu nombre", -1)
const _hoisted_242 = { class: "col-md-6 col-sm-12 col-12 lastname" }
const _hoisted_243 = { class: "form-group" }
const _hoisted_244 = ["disabled"]
const _hoisted_245 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu apellido paterno", -1)
const _hoisted_246 = { class: "col-md-6 col-sm-12 col-12 motherln" }
const _hoisted_247 = { class: "form-group" }
const _hoisted_248 = ["disabled"]
const _hoisted_249 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu apellido materno", -1)
const _hoisted_250 = { class: "titular-dates__form-card card card-form" }
const _hoisted_251 = { class: "PayCard card-body" }
const _hoisted_252 = { class: "visible-mobile" }
const _hoisted_253 = { class: "text-center mt-4 mb-4" }
const _hoisted_254 = /*#__PURE__*/_createElementVNode("span", null, "Aceptamos todas las tarjetas:", -1)
const _hoisted_255 = { class: "payments-cards text-center" }
const _hoisted_256 = { class: "card-brands mt-4" }
const _hoisted_257 = ["src"]
const _hoisted_258 = { class: "hidden-mobile" }
const _hoisted_259 = { class: "payments-cards text-center mt-3 mb-4" }
const _hoisted_260 = /*#__PURE__*/_createElementVNode("span", null, "Aceptamos todas las tarjetas:", -1)
const _hoisted_261 = { class: "card-brands mt-4" }
const _hoisted_262 = ["src"]
const _hoisted_263 = { class: "cardPays" }
const _hoisted_264 = { action: "" }
const _hoisted_265 = { class: "form-group d-none" }
const _hoisted_266 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "Nombres", -1)
const _hoisted_267 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa el titular de la tarjeta", -1)
const _hoisted_268 = { class: "cardPays__form form-group card-form mb-0" }
const _hoisted_269 = { class: "row" }
const _hoisted_270 = { class: "form-group" }
const _hoisted_271 = ["src"]
const _hoisted_272 = ["src"]
const _hoisted_273 = ["src"]
const _hoisted_274 = ["src"]
const _hoisted_275 = ["src"]
const _hoisted_276 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa el número de tu tarjeta", -1)
const _hoisted_277 = ["src"]
const _hoisted_278 = { class: "col-md-6 col-sm-6 col-6" }
const _hoisted_279 = ["src"]
const _hoisted_280 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa una fecha de expiración válida", -1)
const _hoisted_281 = { class: "col-md-6 col-sm-6 col-6" }
const _hoisted_282 = { class: "form-group" }
const _hoisted_283 = ["src"]
const _hoisted_284 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa el código CVV", -1)
const _hoisted_285 = { class: "col-md col-sm-6 col-12" }
const _hoisted_286 = ["disabled"]
const _hoisted_287 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu correo electrónico", -1)
const _hoisted_288 = { class: "col-md col-sm-6 col-12" }
const _hoisted_289 = /*#__PURE__*/_createElementVNode("small", null, "Por favor ingresa tu número de celular", -1)
const _hoisted_290 = { class: "form-group" }
const _hoisted_291 = { class: "custom-control custom-checkbox" }
const _hoisted_292 = {
  class: "custom-control-label",
  for: "customCheckDisabled2"
}
const _hoisted_293 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_294 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_295 = {
  key: 0,
  class: "text-main d-block"
}
const _hoisted_296 = { class: "payment-footer pl-0 pr-0" }
const _hoisted_297 = { class: "hidden-mobile" }
const _hoisted_298 = { class: "backup" }
const _hoisted_299 = ["src"]
const _hoisted_300 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tu compra es 100% segura."),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Somos parte del grupo Intercorp. ")
], -1)
const _hoisted_301 = { class: "visible-mobile" }
const _hoisted_302 = { class: "backup" }
const _hoisted_303 = ["src"]
const _hoisted_304 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Tu compra es 100% segura."),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Somos parte del grupo Intercorp. ")
], -1)
const _hoisted_305 = { class: "visible-mobile" }
const _hoisted_306 = { class: "form-group mt-2 mb-0" }
const _hoisted_307 = ["disabled"]
const _hoisted_308 = { key: 0 }
const _hoisted_309 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_310 = { class: "policies mt-2 mb-2" }
const _hoisted_311 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_312 = /*#__PURE__*/_createElementVNode("div", { class: "Copyright mt-5 mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Copyright © 2020 Interseguro. Todos los derechos reservados")
], -1)
const _hoisted_313 = { class: "col-md-5 col-12" }
const _hoisted_314 = { class: "hidden-mobile" }
const _hoisted_315 = { class: "summary" }
const _hoisted_316 = { class: "summary__section" }
const _hoisted_317 = /*#__PURE__*/_createElementVNode("div", { class: "summary__section__label text-main mb-2" }, " Resumen de pago ", -1)
const _hoisted_318 = { class: "summary__section__detail" }
const _hoisted_319 = /*#__PURE__*/_createElementVNode("span", null, "Pago mensual:", -1)
const _hoisted_320 = { class: "summary__section__detail" }
const _hoisted_321 = /*#__PURE__*/_createElementVNode("span", null, "Período:", -1)
const _hoisted_322 = { class: "summary__section__detail" }
const _hoisted_323 = /*#__PURE__*/_createElementVNode("span", null, "Tu 2da fecha de pago:", -1)
const _hoisted_324 = { class: "summary__section__detail" }
const _hoisted_325 = /*#__PURE__*/_createElementVNode("span", null, "Ganancia:", -1)
const _hoisted_326 = { class: "summary__section__detail" }
const _hoisted_327 = /*#__PURE__*/_createElementVNode("span", null, "Monto de cobertura:", -1)
const _hoisted_328 = /*#__PURE__*/_createElementVNode("div", { class: "summary__section__detail" }, null, -1)
const _hoisted_329 = /*#__PURE__*/_createElementVNode("div", { class: "summary__section__infouser mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Datos del Titular")
], -1)
const _hoisted_330 = { class: "summary__section__detail" }
const _hoisted_331 = { class: "text-upper text-uppercase" }
const _hoisted_332 = { class: "summary__section__detail" }
const _hoisted_333 = /*#__PURE__*/_createElementVNode("span", null, "Nombre:", -1)
const _hoisted_334 = { class: "summary__section__detail" }
const _hoisted_335 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_336 = { class: "summary__section__detail" }
const _hoisted_337 = /*#__PURE__*/_createElementVNode("span", null, "Fecha de Nacimiento:", -1)
const _hoisted_338 = { class: "summary__section__detail" }
const _hoisted_339 = /*#__PURE__*/_createElementVNode("span", null, "Género:", -1)
const _hoisted_340 = { key: 0 }
const _hoisted_341 = { key: 1 }
const _hoisted_342 = { class: "summary__section__detail" }
const _hoisted_343 = /*#__PURE__*/_createElementVNode("span", null, "Celular:", -1)
const _hoisted_344 = { class: "summary__section__detail" }
const _hoisted_345 = /*#__PURE__*/_createElementVNode("span", null, "Correo:", -1)
const _hoisted_346 = { class: "summary__info" }
const _hoisted_347 = /*#__PURE__*/_createStaticVNode("<div class=\"summary__section__detail\"><span class=\"txt w-100 text-center\"> Enviaremos el contrato a tu correo con esta información detallada. </span></div><div class=\"summary__section__detail\"><small class=\"txtblock d-block w-100\"><span>Puedes modificar los beneficiarios de tu seguro de vida enviando un correo a: </span><a href=\"mailto:rumbo@interseguro.com.pe\">rumbo@interseguro.com.pe</a></small></div>", 2)
const _hoisted_349 = { class: "form-group mt-2 mb-0" }
const _hoisted_350 = ["disabled"]
const _hoisted_351 = { key: 0 }
const _hoisted_352 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_353 = { class: "policies mt-2" }
const _hoisted_354 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_355 = { key: 3 }
const _hoisted_356 = { class: "success" }
const _hoisted_357 = /*#__PURE__*/_createElementVNode("h2", null, "¡Felicidades!", -1)
const _hoisted_358 = /*#__PURE__*/_createElementVNode("h3", null, "Ya eres parte de rumbo", -1)
const _hoisted_359 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Cada vez que intentes ingresar a tu "),
  /*#__PURE__*/_createElementVNode("b", null, "Zona Cliente"),
  /*#__PURE__*/_createTextVNode(" con tu DNI, te enviaremos una clave dinámica a tu correo que será válido por 5 minutos, para tu seguridad. ")
], -1)
const _hoisted_360 = { class: "actions text-center justify-content-center" }
const _hoisted_361 = { class: "btn btn-pink" }
const _hoisted_362 = ["src"]
const _hoisted_363 = /*#__PURE__*/_createElementVNode("div", { class: "chat-button__label visible-mobile" }, " Llámanos ", -1)
const _hoisted_364 = /*#__PURE__*/_createElementVNode("div", { class: "chat-button__label hidden-mobile" }, " Llámanos al (01) 614-9288 ", -1)
const _hoisted_365 = ["src"]
const _hoisted_366 = /*#__PURE__*/_createElementVNode("div", { class: "chat-button__label" }, " Comunícate con un asesor vía WhatsApp ", -1)
const _hoisted_367 = ["src"]
const _hoisted_368 = /*#__PURE__*/_createElementVNode("h3", null, "Tu pago se está procesando", -1)
const _hoisted_369 = /*#__PURE__*/_createElementVNode("h4", null, "Espera unos minutos por favor", -1)
const _hoisted_370 = /*#__PURE__*/_createElementVNode("div", { class: "general-conditions" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Condiciones generales"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Para acceder a las condiciones generales y particulares de la póliza, haz clic en los siguientes enlaces: "),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://2xbftadhnj7fo.blob.core.windows.net/public/Condicionado_General.pdf"
    }, "Condicionado General"),
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://2xbftadhnj7fo.blob.core.windows.net/public/Condicionado_Particular.pdf"
    }, "Condicionado Particular")
  ]),
  /*#__PURE__*/_createElementVNode("h3", null, "Exclusiones"),
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
      /*#__PURE__*/_createElementVNode("p", null, "La cobertura escogida incluye:"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, "Fallecimiento por muerte natural.")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
      /*#__PURE__*/_createElementVNode("p", null, "La cobertura escogida NO incluye:"),
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, "Fallecimiento por muerte accidental."),
        /*#__PURE__*/_createElementVNode("li", null, "Enfermedades graves."),
        /*#__PURE__*/_createElementVNode("li", null, "Invalidez total y permanente.")
      ])
    ])
  ])
], -1)
const _hoisted_371 = { class: "general-conditions" }
const _hoisted_372 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Usted puede brindar su consentimiento para que INTERSEGURO, las "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.interseguro.pe/soat/archivo/Pol%C3%ADtica_de_Privacidad_de_Interseguro-Anexo_1.pdf",
    target: "_blank"
  }, "empresas del Grupo Intercorp y/o sus socios comerciales:")
], -1)
const _hoisted_373 = { class: "custom-control custom-checkbox" }
const _hoisted_374 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "chkbxPolicies1"
}, "Realicen estudios de mercado y perfiles de compra. ", -1)
const _hoisted_375 = { class: "custom-control custom-checkbox" }
const _hoisted_376 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "chkbxPolicies2"
}, "Envíen publicidad, promociones y ofertas de los productos y/o servicios. ", -1)
const _hoisted_377 = { class: "custom-control custom-checkbox" }
const _hoisted_378 = ["checked"]
const _hoisted_379 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "chkbxPolicies3"
}, "Sí a todo. ", -1)
const _hoisted_380 = /*#__PURE__*/_createElementVNode("p", null, " Declaro que tengo conocimiento y acepto las Condiciones Generales, Particulares, Especiales y Cláusulas Adicionales relacionadas con la Póliza de Seguros de Interseguro Compañía de Seguros. ", -1)
const _hoisted_381 = /*#__PURE__*/_createElementVNode("p", null, " Certifico que las respuestas y declaraciones realizadas en este sitio web son verídicas y que se ajustan a la realidad y de no serlo, cualquier declaración falsa hecha por el Contratante, voluntaria o involuntariamente, invalida esta solicitud y libera de toda responsabilidad y compromiso indemnizatorio a Interseguro Compañía de Seguros, quedando el seguro emitido en virtud de esta solicitud nulo y sin efecto. ", -1)
const _hoisted_382 = /*#__PURE__*/_createElementVNode("p", null, " El Contratante otorga su consentimiento para que su Póliza de seguro electrónica, endosos futuros, cartas y/u otra documentación, sean enviados vía correo electrónico desde el dominio @interseguro. Todas aquellos documentos y comunicaciones se entenderán por recibidos en la casilla de correo electrónica declarada por el Contratante, a través de la confirmación del servidor de destino. La póliza contendrá una firma digital y una contraseña de acceso para visualizar el documento, ello garantizará la autenticidad e integridad del documento, de acuerdo con lo estipulado en la Ley N° 27269 - Ley de Firmas y Certificados Digitales. Asimismo, declara conocer las medidas de seguridad que debe adoptar para la recepción de los citados documentos, las ventajas y riesgos asociados a esta modalidad de envío, garantiza haber suministrado un correo electrónico válido en la Solicitud de Seguro, el cual mantendrá activo y con espacio suficiente para recibir la Póliza y se comprometen a informar su nuevo correo electrónico, en caso sea dado de baja o desee modificar la cuenta de correo declarada. ", -1)
const _hoisted_383 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Sus datos personales serán utilizados por Interseguro Compañía de Seguros S.A. ("),
  /*#__PURE__*/_createElementVNode("b", null, "INTERSEGURO"),
  /*#__PURE__*/_createTextVNode(") para las siguientes finalidades: ")
], -1)
const _hoisted_384 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode("Para la adquisición de productos de "),
    /*#__PURE__*/_createElementVNode("b", null, "INTERSEGURO")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Enviar documentos de contratación de productos de "),
    /*#__PURE__*/_createElementVNode("b", null, "INTERSEGURO")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createTextVNode(" Realizar cotizaciones de productos de "),
    /*#__PURE__*/_createElementVNode("b", null, "INTERSEGURO"),
    /*#__PURE__*/_createTextVNode(" por solicitud del USUARIO ")
  ])
], -1)
const _hoisted_385 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Para mayor información puedes consultar la   "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro-1810.pdf",
    target: "_blank",
    class: "text-main",
    style: {"text-decoration":"underline"}
  }, "Política de privacidad")
], -1)
const _hoisted_386 = { class: "quote-card" }
const _hoisted_387 = {
  key: 0,
  action: "#"
}
const _hoisted_388 = { class: "d-flex justify-content-start" }
const _hoisted_389 = { class: "form-group" }
const _hoisted_390 = /*#__PURE__*/_createElementVNode("label", { for: "loginDni" }, "DNI", -1)
const _hoisted_391 = { class: "form-group" }
const _hoisted_392 = /*#__PURE__*/_createElementVNode("label", { for: "loginCe" }, "CE", -1)
const _hoisted_393 = { key: 0 }
const _hoisted_394 = { class: "form-group" }
const _hoisted_395 = ["disabled"]
const _hoisted_396 = { key: 0 }
const _hoisted_397 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_398 = { class: "form-group" }
const _hoisted_399 = {
  label: "",
  for: "",
  style: {"position":"initial"}
}
const _hoisted_400 = { key: 0 }
const _hoisted_401 = { class: "form-group" }
const _hoisted_402 = ["disabled"]
const _hoisted_403 = { key: 0 }
const _hoisted_404 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_405 = { class: "modal-login__form" }
const _hoisted_406 = /*#__PURE__*/_createElementVNode("small", null, "Ingrese un email válido", -1)
const _hoisted_407 = { class: "form-group mt-3" }
const _hoisted_408 = ["disabled"]
const _hoisted_409 = { key: 0 }
const _hoisted_410 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_411 = {
  key: 0,
  class: "mt-2 text-success"
}
const _hoisted_412 = { class: "modal-error__header" }
const _hoisted_413 = /*#__PURE__*/_createElementVNode("div", { class: "modal-error__header__message" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Operación Denegada")
], -1)
const _hoisted_414 = { class: "modal-error__img" }
const _hoisted_415 = ["src"]
const _hoisted_416 = { class: "modal-error__head" }
const _hoisted_417 = /*#__PURE__*/_createElementVNode("span", null, "Por favor ingrese una tarjeta de crédito o débito válida", -1)
const _hoisted_418 = { class: "modal-error__head__btn" }
const _hoisted_419 = { class: "modal-error__header" }
const _hoisted_420 = /*#__PURE__*/_createElementVNode("div", { class: "modal-error__header__message" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Operación Denegada")
], -1)
const _hoisted_421 = { class: "modal-error__img" }
const _hoisted_422 = ["src"]
const _hoisted_423 = { class: "modal-error__head" }
const _hoisted_424 = { key: 0 }
const _hoisted_425 = { key: 1 }
const _hoisted_426 = { class: "modal-error__head__btn" }
const _hoisted_427 = { class: "modal-error__header" }
const _hoisted_428 = /*#__PURE__*/_createElementVNode("div", { class: "modal-error__header__message" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Operación Denegada")
], -1)
const _hoisted_429 = { class: "modal-error__img" }
const _hoisted_430 = ["src"]
const _hoisted_431 = { class: "modal-error__head" }
const _hoisted_432 = { class: "modal-error__head__btn" }
const _hoisted_433 = { class: "modal-free-month__head" }
const _hoisted_434 = ["src"]
const _hoisted_435 = { class: "modal-free-month__countdown" }
const _hoisted_436 = { class: "time-box" }
const _hoisted_437 = { class: "time-box__time" }
const _hoisted_438 = /*#__PURE__*/_createElementVNode("div", { class: "time-box__label" }, "Horas", -1)
const _hoisted_439 = { class: "time-box" }
const _hoisted_440 = { class: "time-box__time" }
const _hoisted_441 = /*#__PURE__*/_createElementVNode("div", { class: "time-box__label" }, "Minutos", -1)
const _hoisted_442 = { class: "time-box" }
const _hoisted_443 = { class: "time-box__time" }
const _hoisted_444 = /*#__PURE__*/_createElementVNode("div", { class: "time-box__label" }, "Segundos", -1)
const _hoisted_445 = { class: "modal-free-month__content" }
const _hoisted_446 = { class: "modal-free-month__content__title" }
const _hoisted_447 = { class: "row" }
const _hoisted_448 = { class: "col-2" }
const _hoisted_449 = { class: "title-img" }
const _hoisted_450 = ["src"]
const _hoisted_451 = /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "title__text" }, [
      /*#__PURE__*/_createElementVNode("h4", null, "Tu 2do mes"),
      /*#__PURE__*/_createElementVNode("h5", null, "GRATIS*")
    ])
  ])
], -1)
const _hoisted_452 = ["href"]
const _hoisted_453 = /*#__PURE__*/_createElementVNode("div", { class: "bullets__title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "¿Cómo obtener mi regalo?")
], -1)
const _hoisted_454 = { class: "d-flex justify-content-center bullets__list" }
const _hoisted_455 = /*#__PURE__*/_createElementVNode("li", { class: "bullets__stepone" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1"),
  /*#__PURE__*/_createElementVNode("p", null, " Personaliza tu plan de ahorro en nuestro simulador en línea. ")
], -1)
const _hoisted_456 = /*#__PURE__*/_createElementVNode("li", { class: "bullets__steptwo" }, [
  /*#__PURE__*/_createElementVNode("span", null, "2"),
  /*#__PURE__*/_createElementVNode("p", null, " Afilia una tarjeta de banco de tu preferencia y realiza tu pago. ")
], -1)
const _hoisted_457 = { class: "bullets__stepthree" }
const _hoisted_458 = /*#__PURE__*/_createElementVNode("span", null, "3", -1)
const _hoisted_459 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_460 = ["src"]
const _hoisted_461 = { class: "bullets__list__img" }
const _hoisted_462 = ["src"]
const _hoisted_463 = /*#__PURE__*/_createElementVNode("div", { class: "modal-free-month__content__promo-wpp text-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "*Un mes gratis por cliente, para aportes hasta S/400.")
], -1)
const _hoisted_464 = { class: "action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_b_collapse = _resolveComponent("b-collapse")!
  const _component_Slider = _resolveComponent("Slider")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_card_text = _resolveComponent("b-card-text")!
  const _directive_b_toggle = _resolveDirective("b-toggle")!
  const _directive_mask = _resolveDirective("mask")!
  const _directive_b_modal = _resolveDirective("b-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_router_link, {
            to: { name: 'home' },
            class: "navbar-brand"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                style: {"width":"220px","height":"auto"},
                src: require('@/assets/images/app/logos-Inter.png'),
                loading: "lazy",
                alt: ""
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }),
          _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_5, [
            _createElementVNode("img", {
              src: require('@/assets/images/app/Menu.png'),
              alt: ""
            }, null, 8, _hoisted_6)
          ])), [
            [
              _directive_b_toggle,
              void 0,
              void 0,
              { "nav-head": true }
            ]
          ]),
          _createVNode(_component_b_collapse, {
            class: "collapse navbar-collapse",
            id: "nav-head"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("a", {
        class: "text-decoration-none",
        href: 'https://wa.link/o1y194?utm_source=botmaker&utm_medium=whatsapp&utm_campaign=promocion_rumbo-botmaker-whatsapp-pf-on-rumbo-ahorro',
        target: "_blank"
      }, [
        (_ctx.currentStep.key === 'goal')
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", {
                    href: 'https://wa.link/o1y194?utm_source=botmaker&utm_medium=whatsapp&utm_campaign=promocion_rumbo-botmaker-whatsapp-pf-on-rumbo-ahorro',
                    target: "_blank"
                  }, _hoisted_15, 8, _hoisted_13)
                ]),
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.hours), 1)
                      ]),
                      _hoisted_21
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.minutes < 10 ? "0" + _ctx.minutes : _ctx.minutes), 1)
                      ]),
                      _hoisted_24
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("h6", null, _toDisplayString(_ctx.seconds < 10 ? "0" + _ctx.seconds : _ctx.seconds), 1)
                      ]),
                      _hoisted_27
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_28, [
          (_ctx.currentStep.key === 'goal')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_31))
            : _createCommentVNode("", true)
        ])
      ], 8, _hoisted_9),
      (_ctx.currentStep.key === 'userInfo')
        ? (_openBlock(), _createElementBlock("div", _hoisted_32, _hoisted_34))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            (!_ctx.flags.paymentCompleted)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "btn-back",
                  role: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.prevStep()))
                }, [
                  _createElementVNode("img", {
                    src: require('@/assets/images/app/arrow-back.svg'),
                    alt: ""
                  }, null, 8, _hoisted_39),
                  _createTextVNode(" Regresar ")
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", _hoisted_41, [
            (!_ctx.flags.paymentCompleted)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: step.key
                        }, [
                          (step.key !== 'userInfo')
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass(["quote__stepper__item", {
                      active: step.active,
                      completed: step.completed,
                    }]),
                                onClick: ($event: any) => (_ctx.navigateToStep(step))
                              }, [
                                _createTextVNode(_toDisplayString(step.order) + " ", 1),
                                _createElementVNode("div", _hoisted_46, _toDisplayString(step.label), 1)
                              ], 10, _hoisted_45))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_47, [
              (!_ctx.flags.paymentCompleted)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "quote__step__back",
                    role: "button",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.prevStep()))
                  }, [
                    _createElementVNode("img", {
                      src: require('@/assets/images/app/arrow-back.svg'),
                      alt: ""
                    }, null, 8, _hoisted_48)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.flags.paymentCompleted)
                ? (_openBlock(), _createElementBlock("h4", _hoisted_49, _toDisplayString(_ctx.currentStep.title), 1))
                : _createCommentVNode("", true),
              (!_ctx.flags.paymentCompleted)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (_ctx.currentStep.key === 'userInfo')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _hoisted_52,
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("form", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["form-group", {
                                  invalid:
                                    this.v$.userInfo.firstName.$error,
                                }])
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control",
                                          placeholder: "Nombres",
                                          disabled: _ctx.flags.searching,
                                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((this.v$.userInfo.firstName.$model) = $event))
                                        }, null, 8, _hoisted_58), [
                                          [_vModelText, this.v$.userInfo.firstName.$model]
                                        ]),
                                        _hoisted_59
                                      ], 2)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_60, [
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["form-group", {
                                  invalid:
                                    this.v$.userInfo.lastName.$error,
                                }])
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control",
                                          placeholder: "Apellido paterno",
                                          disabled: _ctx.flags.searching,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((this.v$.userInfo.lastName.$model) = $event))
                                        }, null, 8, _hoisted_62), [
                                          [_vModelText, this.v$.userInfo.lastName.$model]
                                        ]),
                                        _hoisted_63
                                      ], 2)
                                    ]),
                                    _createElementVNode("div", _hoisted_64, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["form-group", {
                                  invalid:
                                    this.v$.userInfo.secondLastName.$error,
                                }])
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control",
                                          placeholder: "Apellido materno",
                                          disabled: _ctx.flags.searching,
                                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((this.v$.userInfo.secondLastName.$model) = $event))
                                        }, null, 8, _hoisted_65), [
                                          [_vModelText, this.v$.userInfo.secondLastName.$model]
                                        ]),
                                        _hoisted_66
                                      ], 2)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_67, [
                                    _createElementVNode("div", _hoisted_68, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["form-group", {invalid:this.v$.userInfo.dateOfBirth.$error || _ctx.flags.invalidAge,}])
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control",
                                          placeholder: "Fecha de nacimiento",
                                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((this.v$.userInfo.inputDob.$model) = $event)),
                                          onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changePlaceholder && _ctx.changePlaceholder(...args))),
                                          onBlur: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.revertPlaceholder && _ctx.revertPlaceholder(...args))),
                                          onKeyup: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.validateDob && _ctx.validateDob(...args)))
                                        }, null, 544), [
                                          [_vModelText, this.v$.userInfo.inputDob.$model],
                                          [_directive_mask, '##/##/####']
                                        ]),
                                        (!_ctx.flags.invalidAge)
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_69, "Por favor ingresa tu fecha de nacimiento"))
                                          : _createCommentVNode("", true),
                                        (_ctx.flags.invalidAge)
                                          ? (_openBlock(), _createElementBlock("small", _hoisted_70, "Por favor ingresa una fecha válida"))
                                          : _createCommentVNode("", true)
                                      ], 2)
                                    ]),
                                    _createElementVNode("div", _hoisted_71, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["form-group", {invalid: this.v$.userInfo.gender.$error,}])
                                      }, [
                                        _withDirectives(_createElementVNode("select", {
                                          class: "form-select form-control",
                                          "aria-label": "Default select example",
                                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((this.v$.userInfo.gender.$model) = $event))
                                        }, _hoisted_75, 512), [
                                          [_vModelSelect, this.v$.userInfo.gender.$model]
                                        ]),
                                        _hoisted_76
                                      ], 2)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_77, [
                                    _createElementVNode("div", _hoisted_78, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["form-group", {invalid: this.v$.userInfo.phone.$error,}])
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "form-control",
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((this.v$.userInfo.phone.$model) = $event)),
                                          onKeydown: _cache[11] || (_cache[11] = ($event: any) => (_ctx.validateInput($event, /^[0-9]*$/))),
                                          maxlength: "9",
                                          placeholder: "Celular",
                                          "data-culqi": "card[phone]",
                                          id: "card[phone]"
                                        }, null, 544), [
                                          [_vModelText, this.v$.userInfo.phone.$model]
                                        ]),
                                        _hoisted_79
                                      ], 2)
                                    ]),
                                    _createElementVNode("div", _hoisted_80, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["form-group", {invalid: this.v$.userInfo.email.$error,}])
                                      }, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "email",
                                          class: "form-control",
                                          placeholder: "Correo electrónico",
                                          disabled: _ctx.flags.searching,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((this.v$.userInfo.email.$model) = $event)),
                                          "data-culqi": "card[email]",
                                          id: "card[email]"
                                        }, null, 8, _hoisted_81), [
                                          [_vModelText, this.v$.userInfo.email.$model]
                                        ]),
                                        _hoisted_82
                                      ], 2)
                                    ])
                                  ]),
                                  (_ctx.flags.olderThanAllowedAge)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_83, _hoisted_85))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_86, [
                                    _createElementVNode("button", {
                                      class: "btn btn-pink btn-send",
                                      type: "button",
                                      disabled: _ctx.flags.searching,
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.nextStep()))
                                    }, " Continuar ", 8, _hoisted_87)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_88, [
                                _createElementVNode("div", _hoisted_89, [
                                  _createElementVNode("a", _hoisted_90, [
                                    _createElementVNode("img", {
                                      src: require('@/assets/images/app/newWpp.png'),
                                      alt: "",
                                      width: "160",
                                      loading: "lazy"
                                    }, null, 8, _hoisted_91),
                                    _hoisted_92
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.currentStep.key === 'goal')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("div", _hoisted_93, [
                            _createElementVNode("div", _hoisted_94, [
                              _createElementVNode("div", _hoisted_95, [
                                _createElementVNode("div", _hoisted_96, [
                                  _createElementVNode("div", _hoisted_97, [
                                    _createElementVNode("form", _hoisted_98, [
                                      _createElementVNode("div", _hoisted_99, [
                                        _hoisted_100,
                                        _createElementVNode("div", _hoisted_101, [
                                          _createVNode(_component_Slider, {
                                            modelValue: this.v$.goal.amount.$model,
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((this.v$.goal.amount.$model) = $event)),
                                            step: _ctx.amountSlider.interval,
                                            format: { prefix: 'S/ ' },
                                            min: _ctx.amountSlider.min,
                                            max: _ctx.amountSlider.max,
                                            orientation: 'horizontal',
                                            onChange: _ctx.changeAmount
                                          }, null, 8, ["modelValue", "step", "min", "max", "onChange"]),
                                          _createElementVNode("span", _hoisted_102, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.amountSlider.min)), 1),
                                          _createElementVNode("span", _hoisted_103, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.amountSlider.max)), 1)
                                        ])
                                      ]),
                                      (!_ctx.flags.loadingPlans)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                            _hoisted_105,
                                            _createElementVNode("div", _hoisted_106, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option, index) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "custom-control custom-radio custom-control-inline",
                                                  key: option.id
                                                }, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "radio",
                                                    id: 'radioPlan' + option.id,
                                                    name: "radioPlan",
                                                    class: "custom-control-input",
                                                    value: option.id,
                                                    "onUpdate:modelValue": ($event: any) => ((_ctx.goal.option) = $event),
                                                    onChange: ($event: any) => (_ctx.changeOption(option))
                                                  }, null, 40, _hoisted_107), [
                                                    [_vModelRadio, _ctx.goal.option]
                                                  ]),
                                                  _createElementVNode("label", {
                                                    class: "custom-control-label",
                                                    for: 'radioPlan' + option.id
                                                  }, _toDisplayString(option.duration) + " años", 9, _hoisted_108)
                                                ]))
                                              }), 128))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.flags.loadingPlans)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, _hoisted_112))
                                        : _createCommentVNode("", true),
                                      (_ctx.allOptions.length === 0 && !_ctx.flags.loadingPlans
                                )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_113, _hoisted_115))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", _hoisted_116, [
                                        (_ctx.selectedOption)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                                              _createElementVNode("div", _hoisted_118, [
                                                _createElementVNode("div", _hoisted_119, [
                                                  _hoisted_120,
                                                  _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.saved)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_121, [
                                                  _hoisted_122,
                                                  _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.won)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_123, [
                                                  _hoisted_124,
                                                  _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.amount)), 1)
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_125, [
                                                _hoisted_126,
                                                _createElementVNode("div", _hoisted_127, _toDisplayString(_ctx.selectedOption.tea) + "% ", 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _hoisted_128
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("div", _hoisted_130, [
                                  _createElementVNode("div", _hoisted_131, [
                                    _createElementVNode("div", _hoisted_132, [
                                      _createElementVNode("button", {
                                        class: "btn btn-pink btn-send",
                                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setOption(_ctx.selectedOption)))
                                      }, " Continuar ")
                                    ]),
                                    _createElementVNode("div", _hoisted_133, [
                                      _createElementVNode("button", {
                                        class: "btn btn-outline-main btn-quote",
                                        type: "button",
                                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.openQuoteModal()))
                                      }, [
                                        _createTextVNode(" Enviar cotización "),
                                        _createElementVNode("img", {
                                          src: require('@/assets/images/app/send-quote.svg')
                                  ,
                                          alt: ""
                                        }, null, 8, _hoisted_134)
                                      ])
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_135, [
                                (_ctx.selectedOption)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                                      _createElementVNode("div", _hoisted_137, [
                                        _createElementVNode("div", _hoisted_138, [
                                          _createElementVNode("a", _hoisted_139, [
                                            _createElementVNode("img", {
                                              src: require('@/assets/images/app/newWpp.png')
                                  ,
                                              alt: "",
                                              width: "160",
                                              loading: "lazy"
                                            }, null, 8, _hoisted_140),
                                            _hoisted_141
                                          ])
                                        ])
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_142, [
                              _createElementVNode("div", _hoisted_143, [
                                (_ctx.selectedOption)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_144, [
                                      _hoisted_145,
                                      _createElementVNode("div", _hoisted_146, [
                                        _createElementVNode("div", _hoisted_147, [
                                          _hoisted_148,
                                          _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.saved)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_149, [
                                          _hoisted_150,
                                          _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.won)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_151, [
                                          _hoisted_152,
                                          _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.amount)), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_153, [
                                        _createTextVNode(" Mi TREA es: "),
                                        _createElementVNode("div", _hoisted_154, _toDisplayString(_ctx.selectedOption.tea) + "% ", 1),
                                        _hoisted_155
                                      ]),
                                      _createElementVNode("div", _hoisted_156, [
                                        _createElementVNode("button", {
                                          class: "btn btn-pink btn-send",
                                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setOption(_ctx.selectedOption)))
                                        }, " Continuar ")
                                      ]),
                                      _createElementVNode("div", _hoisted_157, [
                                        _withDirectives((_openBlock(), _createElementBlock("button", {
                                          class: "btn btn-outline-main btn-quote",
                                          type: "button",
                                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.openQuoteModal()))
                                        }, [
                                          _createTextVNode(" Enviar cotización "),
                                          _createElementVNode("img", {
                                            src: require('@/assets/images/app/send-quote.svg')
                                ,
                                            alt: ""
                                          }, null, 8, _hoisted_158)
                                        ])), [
                                          [_directive_b_modal, 'modal-quote']
                                        ])
                                      ]),
                                      _hoisted_159
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          (_ctx.selectedOption && false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_160, [
                                _createElementVNode("div", _hoisted_161, [
                                  _createElementVNode("div", _hoisted_162, [
                                    _createElementVNode("div", _hoisted_163, [
                                      _createElementVNode("div", _hoisted_164, [
                                        _createElementVNode("div", _hoisted_165, [
                                          _createElementVNode("div", _hoisted_166, " S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.saved)), 1),
                                          _hoisted_167
                                        ]),
                                        _hoisted_168,
                                        _createElementVNode("div", _hoisted_169, [
                                          _createElementVNode("div", _hoisted_170, " S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.won)), 1),
                                          _hoisted_171
                                        ]),
                                        _hoisted_172,
                                        _createElementVNode("div", _hoisted_173, [
                                          _createElementVNode("div", _hoisted_174, [
                                            _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.amount)), 1)
                                          ]),
                                          _hoisted_175
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.selectedOption && false)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                                _createElementVNode("div", _hoisted_177, [
                                  _createElementVNode("div", _hoisted_178, [
                                    _createElementVNode("div", _hoisted_179, [
                                      _createElementVNode("div", _hoisted_180, " Al término de " + _toDisplayString(_ctx.selectedOption.duration) + " años, obtendrás (rentabilidad garantizada): ", 1),
                                      _createElementVNode("div", _hoisted_181, [
                                        _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.amount)), 1),
                                        _createElementVNode("span", null, [
                                          _createElementVNode("span", _hoisted_182, _toDisplayString(_ctx.selectedOption.tea) + "%", 1),
                                          _hoisted_183,
                                          _createTextVNode(" (TEA referencial) ")
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_184, [
                                      _createElementVNode("button", {
                                        class: "btn btn-pink",
                                        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.setOption(_ctx.selectedOption)))
                                      }, " ¡Lo quiero! "),
                                      _createElementVNode("button", {
                                        class: "btn btn-quote",
                                        onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.openQuoteModal()))
                                      }, " Enviar cotización ")
                                    ])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true),
                    (_ctx.currentStep.key === 'payment')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                          _createElementVNode("div", _hoisted_186, [
                            _hoisted_187,
                            _createElementVNode("div", _hoisted_188, [
                              _createElementVNode("form", _hoisted_189, [
                                _createElementVNode("div", _hoisted_190, [
                                  _createElementVNode("div", _hoisted_191, [
                                    _createElementVNode("div", _hoisted_192, [
                                      _createElementVNode("div", _hoisted_193, [
                                        _createElementVNode("div", _hoisted_194, [
                                          _createElementVNode("div", _hoisted_195, [
                                            _createTextVNode(" Resumen de pago "),
                                            _createElementVNode("button", {
                                              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.awesome = !_ctx.awesome)),
                                              type: "button"
                                            }, [
                                              (_ctx.awesome)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_196, _hoisted_198))
                                                : _createCommentVNode("", true),
                                              (!_ctx.awesome)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_199, _hoisted_201))
                                                : _createCommentVNode("", true)
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_202, [
                                              _hoisted_203,
                                              _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.goal.amount)), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_204, [
                                              _hoisted_205,
                                              _createElementVNode("b", null, _toDisplayString(_ctx.selectedOption.duration) + " años", 1)
                                            ])
                                          ]),
                                          (!_ctx.awesome)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_206, [
                                                _createElementVNode("div", _hoisted_207, [
                                                  _hoisted_208,
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.nextPaymentDate), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_209, [
                                                  _hoisted_210,
                                                  _createTextVNode(" S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.won)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_211, [
                                                  _hoisted_212,
                                                  _createTextVNode(" S/ " + _toDisplayString(_ctx.formatNumber(_ctx.goal.coverage)), 1)
                                                ]),
                                                _hoisted_213,
                                                _createElementVNode("div", _hoisted_214, [
                                                  _createElementVNode("span", _hoisted_215, _toDisplayString(_ctx.userInfo.identificationType) + ":", 1),
                                                  _createTextVNode(" " + _toDisplayString(_ctx.userInfo.identificationNumber), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_216, [
                                                  _hoisted_217,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.payment.firstName), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_218, [
                                                  _hoisted_219,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.payment.lastName) + " " + _toDisplayString(_ctx.payment.secondLastName), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_220, [
                                                  _hoisted_221,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.userInfo.inputDob), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_222, [
                                                  _hoisted_223,
                                                  (_ctx.userInfo.gender === 'M')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_224, "Masculino"))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.userInfo.gender === 'F')
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_225, "Femenino"))
                                                    : _createCommentVNode("", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_226, [
                                                  _hoisted_227,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.userInfo.phone), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_228, [
                                                  _hoisted_229,
                                                  _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.email), 1)
                                                ]),
                                                _hoisted_230
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_231, [
                                    _createElementVNode("div", _hoisted_232, [
                                      _hoisted_233,
                                      _createElementVNode("div", _hoisted_234, [
                                        _createElementVNode("div", _hoisted_235, [
                                          _createElementVNode("form", _hoisted_236, [
                                            _createElementVNode("div", _hoisted_237, [
                                              _createElementVNode("div", _hoisted_238, [
                                                _createElementVNode("div", _hoisted_239, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    placeholder: "Nombres",
                                                    disabled: _ctx.flags.searching,
                                                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((this.v$.payment.firstName.$model
                                                ) = $event)),
                                                    onKeydown: _cache[23] || (_cache[23] = ($event: any) => (
    _ctx.validateInput(
      $event,
      /^[a-zA-Z\s]*$/
    )
    ))
                                                  }, null, 40, _hoisted_240), [
                                                    [_vModelText, this.v$.payment.firstName.$model
                                                ]
                                                  ]),
                                                  _hoisted_241
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_242, [
                                                _createElementVNode("div", _hoisted_243, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    placeholder: "Apellido paterno",
                                                    disabled: _ctx.flags.searching,
                                                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((this.v$.payment.lastName.$model
                                                ) = $event)),
                                                    onKeydown: _cache[25] || (_cache[25] = ($event: any) => (
    _ctx.validateInput(
      $event,
      /^[a-zA-Z\s]*$/
    )
    ))
                                                  }, null, 40, _hoisted_244), [
                                                    [_vModelText, this.v$.payment.lastName.$model
                                                ]
                                                  ]),
                                                  _hoisted_245
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_246, [
                                                _createElementVNode("div", _hoisted_247, [
                                                  _withDirectives(_createElementVNode("input", {
                                                    type: "text",
                                                    class: "form-control",
                                                    placeholder: "Apellido materno",
                                                    disabled: _ctx.flags.searching,
                                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((this.v$.payment.secondLastName
                                                .$model
                                                ) = $event)),
                                                    onKeydown: _cache[27] || (_cache[27] = ($event: any) => (
    _ctx.validateInput(
      $event,
      /^[a-zA-Z\s]*$/
    )
    ))
                                                  }, null, 40, _hoisted_248), [
                                                    [_vModelText, this.v$.payment.secondLastName
                                                .$model
                                                ]
                                                  ]),
                                                  _hoisted_249
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_250, [
                                      _createElementVNode("div", _hoisted_251, [
                                        _createElementVNode("div", _hoisted_252, [
                                          _createElementVNode("div", _hoisted_253, [
                                            _hoisted_254,
                                            _createElementVNode("div", _hoisted_255, [
                                              _createElementVNode("div", _hoisted_256, [
                                                _createElementVNode("img", {
                                                  src: require('@/assets/images/app/card-brands.png')
                                            ,
                                                  alt: "",
                                                  class: "input-icon-left"
                                                }, null, 8, _hoisted_257)
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_258, [
                                          _createElementVNode("div", _hoisted_259, [
                                            _hoisted_260,
                                            _createElementVNode("div", _hoisted_261, [
                                              _createElementVNode("img", {
                                                src: require('@/assets/images/app/card-brands.png')
                                          ,
                                                alt: "",
                                                class: "input-icon-left"
                                              }, null, 8, _hoisted_262)
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_263, [
                                          _createElementVNode("form", _hoisted_264, [
                                            _createElementVNode("div", _hoisted_265, [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((this.v$.payment.placeholder.$model
                                          ) = $event))
                                              }, null, 512), [
                                                [_vModelText, this.v$.payment.placeholder.$model
                                          ]
                                              ]),
                                              _withDirectives(_createElementVNode("input", {
                                                type: "hidden",
                                                class: "form-control",
                                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((this.v$.payment.email.$model) = $event)),
                                                "data-culqi": "card[email]",
                                                id: "card[email]"
                                              }, null, 512), [
                                                [_vModelText, this.v$.payment.email.$model]
                                              ]),
                                              _hoisted_266,
                                              _hoisted_267
                                            ]),
                                            _createElementVNode("div", _hoisted_268, [
                                              _createElementVNode("div", _hoisted_269, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["col-md-12 col-sm-12 col-12", {
                                            invalid:
                                              this.v$.payment.creditCardNumber
                                                .$error,
                                          }])
                                                }, [
                                                  _createElementVNode("div", _hoisted_270, [
                                                    (_ctx.payment.creditCardType === ''
    )
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 0,
                                                          src: require('@/assets/images/app/Trazado14308.svg')
                                                ,
                                                          alt: "",
                                                          class: "input-icon-left"
                                                        }, null, 8, _hoisted_271))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.payment.creditCardType ===
    'VISA'
    )
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 1,
                                                          src: require('@/assets/images/app/visa.svg')
                                                ,
                                                          alt: "",
                                                          class: "input-card"
                                                        }, null, 8, _hoisted_272))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.payment.creditCardType ===
    'MASTERCARD'
    )
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 2,
                                                          src: require('@/assets/images/app/mc.svg')
                                                ,
                                                          alt: "",
                                                          class: "input-card"
                                                        }, null, 8, _hoisted_273))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.payment.creditCardType ===
    'DINERS'
    )
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 3,
                                                          src: require('@/assets/images/app/diners.svg')
                                                ,
                                                          alt: "",
                                                          class: "input-card"
                                                        }, null, 8, _hoisted_274))
                                                      : _createCommentVNode("", true),
                                                    (_ctx.payment.creditCardType ===
    'AMEX'
    )
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 4,
                                                          src: require('@/assets/images/app/amex.svg')
                                                ,
                                                          alt: "",
                                                          class: "input-card"
                                                        }, null, 8, _hoisted_275))
                                                      : _createCommentVNode("", true),
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "text",
                                                      class: "form-control cc-input",
                                                      placeholder: "Número de tarjeta",
                                                      "data-culqi": "card[number]",
                                                      id: "card[number]",
                                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((this.v$.payment
                                                  .creditCardNumber.$model
                                                  ) = $event)),
                                                      onKeyup: _cache[31] || (_cache[31] = ($event: any) => (_ctx.validateCreditCard())),
                                                      onChange: _cache[32] || (_cache[32] = ($event: any) => (_ctx.savePaymentEvent()))
                                                    }, null, 544), [
                                                      [_directive_mask, '#### #### #### ####'],
                                                      [_vModelText, this.v$.payment
                                                  .creditCardNumber.$model
                                                  ]
                                                    ]),
                                                    _hoisted_276,
                                                    (_ctx.payment.validCard)
                                                      ? (_openBlock(), _createElementBlock("img", {
                                                          key: 5,
                                                          src: require('@/assets/images/app/check-color.svg')
                                                ,
                                                          class: "valid-card-icon",
                                                          alt: ""
                                                        }, null, 8, _hoisted_277))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ], 2),
                                                _createElementVNode("div", _hoisted_278, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["form-group", {
                                              invalid:
                                                this.v$.payment.expirationDate
                                                  .$error ||
                                                this.flags
                                                  .invalidExpirationDate,
                                            }])
                                                  }, [
                                                    _createElementVNode("img", {
                                                      src: require('@/assets/images/app/img1.svg')
                                                ,
                                                      alt: "",
                                                      class: "input-icon-left"
                                                    }, null, 8, _hoisted_279),
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "text",
                                                      class: "form-control",
                                                      placeholder: "MM/AA",
                                                      maxlength: "5",
                                                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((this.v$.payment.expirationDate
                                                  .$model
                                                  ) = $event)),
                                                      onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.setExpirationDate())),
                                                      onKeydown: _cache[35] || (_cache[35] = ($event: any) => (
    _ctx.validateInput($event, /^\d+$/)
    ))
                                                    }, null, 544), [
                                                      [_vModelText, this.v$.payment.expirationDate
                                                  .$model
                                                  ],
                                                      [_directive_mask, '##/##']
                                                    ]),
                                                    _hoisted_280,
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "hidden",
                                                      size: "2",
                                                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((this.v$.payment.month.$model
                                                ) = $event)),
                                                      "data-culqi": "card[exp_month]",
                                                      id: "card[exp_month]"
                                                    }, null, 512), [
                                                      [_vModelText, this.v$.payment.month.$model
                                                ]
                                                    ]),
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "hidden",
                                                      size: "4",
                                                      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((this.v$.payment.year.$model
                                                ) = $event)),
                                                      "data-culqi": "card[exp_year]",
                                                      id: "card[exp_year]"
                                                    }, null, 512), [
                                                      [_vModelText, this.v$.payment.year.$model
                                                ]
                                                    ])
                                                  ], 2)
                                                ]),
                                                _createElementVNode("div", _hoisted_281, [
                                                  _createElementVNode("div", _hoisted_282, [
                                                    _createElementVNode("img", {
                                                      src: require('@/assets/images/app/lock.svg')
                                                ,
                                                      alt: "",
                                                      class: "input-icon-left"
                                                    }, null, 8, _hoisted_283),
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "text",
                                                      class: "form-control",
                                                      placeholder: "CVV",
                                                      maxlength: "5",
                                                      "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((this.v$.payment.maskedCvv
                                                  .$model
                                                  ) = $event)),
                                                      onChange: _cache[39] || (_cache[39] = ($event: any) => {
    _ctx.maskCvv();
  _ctx.savePaymentEvent();
  }),
                                                      onKeydown: _cache[40] || (_cache[40] = ($event: any) => (
  _ctx.validateInput($event, /^\d+$/)
  ))
                                                    }, null, 544), [
                                                      [_vModelText, this.v$.payment.maskedCvv
                                                  .$model
                                                  ]
                                                    ]),
                                                    _hoisted_284,
                                                    _withDirectives(_createElementVNode("input", {
                                                      type: "hidden",
                                                      size: "4",
                                                      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((this.v$.payment.cvv.$model
                                                ) = $event)),
                                                      "data-culqi": "card[cvv]",
                                                      id: "card[cvv]"
                                                    }, null, 512), [
                                                      [_vModelText, this.v$.payment.cvv.$model
                                                ]
                                                    ])
                                                  ])
                                                ]),
                                                (_ctx.existingUser)
                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                      _createElementVNode("div", _hoisted_285, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["form-group", {
                                                invalid:
                                                  this.v$.payment.email
                                                    .$error,
                                              }])
                                                        }, [
                                                          _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            class: "form-control",
                                                            placeholder: "Correo electrónico",
                                                            disabled: _ctx.flags.searching,
                                                            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((this.v$.payment.email.$model
                                                    ) = $event)),
                                                            onChange: _cache[43] || (_cache[43] = ($event: any) => (
    _ctx.updateUserInfo('email')
    )),
                                                            "data-culqi": "card[email]",
                                                            id: "card[email]"
                                                          }, null, 40, _hoisted_286), [
                                                            [_vModelText, this.v$.payment.email.$model
                                                    ]
                                                          ]),
                                                          _hoisted_287
                                                        ], 2)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_288, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(["form-group", {
                                                invalid:
                                                  this.v$.payment.phone
                                                    .$error,
                                              }])
                                                        }, [
                                                          _withDirectives(_createElementVNode("input", {
                                                            type: "text",
                                                            class: "form-control",
                                                            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((this.v$.payment.phone.$model
                                                  ) = $event)),
                                                            onChange: _cache[45] || (_cache[45] = ($event: any) => (
    _ctx.updateUserInfo('phone')
    )),
                                                            maxlength: "9",
                                                            placeholder: "Número de celular",
                                                            "data-culqi": "card[phone]",
                                                            id: "card[phone]"
                                                          }, null, 544), [
                                                            [_vModelText, this.v$.payment.phone.$model
                                                  ]
                                                          ]),
                                                          _hoisted_289
                                                        ], 2)
                                                      ])
                                                    ], 64))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_290, [
                                              _createElementVNode("div", _hoisted_291, [
                                                _withDirectives(_createElementVNode("input", {
                                                  type: "checkbox",
                                                  class: "custom-control-input",
                                                  id: "customCheckDisabled2",
                                                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.automaticDebit) = $event))
                                                }, null, 512), [
                                                  [_vModelCheckbox, _ctx.automaticDebit]
                                                ]),
                                                _createElementVNode("label", _hoisted_292, [
                                                  _createTextVNode(" Deseo afiliarme al débito automático "),
                                                  _hoisted_293,
                                                  _hoisted_294,
                                                  (!_ctx.automaticDebit)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_295, "¿Estás seguro? ¡Los clientes que usan afiliación automática llegan a sus objetivos de ahorro 3 veces más rápido!"))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_296, [
                                      _createElementVNode("div", _hoisted_297, [
                                        _createElementVNode("div", _hoisted_298, [
                                          _createElementVNode("img", {
                                            src: require('@/assets/images/app/card-lock.png')
                                      ,
                                            alt: "",
                                            class: "input-icon-left"
                                          }, null, 8, _hoisted_299),
                                          _hoisted_300
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_301, [
                                        _createElementVNode("div", _hoisted_302, [
                                          _createElementVNode("img", {
                                            src: require('@/assets/images/app/card-lock.png')
                                      ,
                                            alt: "",
                                            class: "input-icon-left"
                                          }, null, 8, _hoisted_303),
                                          _hoisted_304
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_305, [
                                        _createElementVNode("div", _hoisted_306, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-pink btn-send",
                                            onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.placeOrder())),
                                            disabled: _ctx.flags.paying
                                          }, [
                                            (!_ctx.flags.paying)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_308, "Pagar"))
                                              : _createCommentVNode("", true),
                                            (_ctx.flags.paying)
                                              ? (_openBlock(), _createElementBlock("i", _hoisted_309))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_307)
                                        ]),
                                        _createElementVNode("div", _hoisted_310, [
                                          _createTextVNode(" Al continuar acepto las "),
                                          _withDirectives((_openBlock(), _createElementBlock("a", null, [
                                            _createTextVNode("Condiciones y exclusiones")
                                          ])), [
                                            [
                                              _directive_b_modal,
                                              void 0,
                                              void 0,
                                              { "modal-policies": true }
                                            ]
                                          ]),
                                          _createTextVNode(" de la póliza. "),
                                          _hoisted_311,
                                          _createTextVNode(" Autorizo el envío de póliza electrónica y comunicaciones de Interseguro a mi correo. ")
                                        ]),
                                        _hoisted_312
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_313, [
                                    _createElementVNode("div", _hoisted_314, [
                                      _createElementVNode("div", _hoisted_315, [
                                        _createElementVNode("div", _hoisted_316, [
                                          _hoisted_317,
                                          _createElementVNode("div", _hoisted_318, [
                                            _hoisted_319,
                                            _createElementVNode("b", null, "S/ " + _toDisplayString(_ctx.formatNumber(_ctx.goal.amount)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_320, [
                                            _hoisted_321,
                                            _createElementVNode("b", null, _toDisplayString(_ctx.selectedOption.duration) + " años", 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_322, [
                                            _hoisted_323,
                                            _createElementVNode("span", null, _toDisplayString(_ctx.nextPaymentDate), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_324, [
                                            _hoisted_325,
                                            _createTextVNode(" S/ " + _toDisplayString(_ctx.formatNumber(_ctx.selectedOption.won)), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_326, [
                                            _hoisted_327,
                                            _createTextVNode(" S/ " + _toDisplayString(_ctx.formatNumber(_ctx.goal.coverage)), 1)
                                          ]),
                                          _hoisted_328,
                                          _hoisted_329,
                                          _createElementVNode("div", _hoisted_330, [
                                            _createElementVNode("span", _hoisted_331, _toDisplayString(_ctx.userInfo.identificationType) + ":", 1),
                                            _createTextVNode(" " + _toDisplayString(_ctx.userInfo.identificationNumber), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_332, [
                                            _hoisted_333,
                                            _createTextVNode(" " + _toDisplayString(_ctx.payment.firstName), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_334, [
                                            _hoisted_335,
                                            _createTextVNode(" " + _toDisplayString(_ctx.payment.lastName) + " " + _toDisplayString(_ctx.payment.secondLastName), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_336, [
                                            _hoisted_337,
                                            _createTextVNode(" " + _toDisplayString(_ctx.userInfo.inputDob), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_338, [
                                            _hoisted_339,
                                            (_ctx.userInfo.gender === 'M')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_340, "Masculino"))
                                              : _createCommentVNode("", true),
                                            (_ctx.userInfo.gender === 'F')
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_341, "Femenino"))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", _hoisted_342, [
                                            _hoisted_343,
                                            _createTextVNode(" " + _toDisplayString(_ctx.userInfo.phone), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_344, [
                                            _hoisted_345,
                                            _createElementVNode("span", null, _toDisplayString(_ctx.userInfo.email), 1)
                                          ]),
                                          _createElementVNode("div", _hoisted_346, [
                                            _hoisted_347,
                                            _createElementVNode("div", _hoisted_349, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-pink btn-send",
                                                onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.placeOrder())),
                                                disabled: _ctx.flags.paying
                                              }, [
                                                (!_ctx.flags.paying)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_351, "Pagar"))
                                                  : _createCommentVNode("", true),
                                                (_ctx.flags.paying)
                                                  ? (_openBlock(), _createElementBlock("i", _hoisted_352))
                                                  : _createCommentVNode("", true)
                                              ], 8, _hoisted_350)
                                            ]),
                                            _createElementVNode("div", _hoisted_353, [
                                              _createTextVNode(" Al continuar acepto las "),
                                              _withDirectives((_openBlock(), _createElementBlock("a", null, [
                                                _createTextVNode("Condiciones y exclusiones")
                                              ])), [
                                                [
                                                  _directive_b_modal,
                                                  void 0,
                                                  void 0,
                                                  { "modal-policies": true }
                                                ]
                                              ]),
                                              _createTextVNode(" de la póliza. "),
                                              _hoisted_354,
                                              _createTextVNode(" Autorizo el envío de póliza electrónica y comunicaciones de Interseguro a mi correo. ")
                                            ])
                                          ])
                                        ])
                                      ])
                                    ])
                                  ])
                                ])
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.flags.paymentCompleted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_355, [
                    _createElementVNode("div", _hoisted_356, [
                      _hoisted_357,
                      _createElementVNode("h3", null, [
                        _createTextVNode(" Tu póliza "),
                        _createElementVNode("b", null, _toDisplayString(_ctx.policyNumber), 1),
                        _createTextVNode(" ha sido creada. ")
                      ]),
                      _hoisted_358,
                      _hoisted_359,
                      _createElementVNode("div", _hoisted_360, [
                        _withDirectives((_openBlock(), _createElementBlock("button", _hoisted_361, [
                          _createTextVNode(" Zona Cliente ")
                        ])), [
                          [
                            _directive_b_modal,
                            void 0,
                            void 0,
                            { "modal-login": true }
                          ]
                        ]),
                        _createElementVNode("button", {
                          class: "btn btn-outline-main",
                          onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.goHome()))
                        }, " Salir ")
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _createElementVNode("a", {
        class: "chat-button phone",
        id: "chatButton",
        target: "_blank",
        href: "tel:016149288",
        onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.openWapp()))
      }, [
        _createElementVNode("img", {
          src: require('@/assets/images/app/newWpp.png'),
          alt: "",
          width: "160",
          loading: "lazy"
        }, null, 8, _hoisted_362),
        _hoisted_363,
        _hoisted_364
      ]),
      _createElementVNode("a", {
        class: "chat-button hidden-mobile",
        id: "chatButton",
        target: "_blank",
        href: "https://api.whatsapp.com/send?phone=51946523076&text=Hola%2C%20Rumbo.%20%C2%A1Deseo%20m%C3%A1s%20informaci%C3%B3n!",
        onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.openWapp()))
      }, [
        _createElementVNode("img", {
          src: require('@/assets/images/app/wapp-chat.svg'),
          alt: "",
          width: "160",
          loading: "lazy"
        }, null, 8, _hoisted_365),
        _hoisted_366
      ])
    ]),
    _createVNode(_component_b_modal, {
      id: "modal-loading",
      centered: "",
      "hide-backdrop": "",
      size: "sm",
      "modal-class": "modal-loading",
      ref: "modal-loading"
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: require('@/assets/images/app/clock.gif'),
          alt: ""
        }, null, 8, _hoisted_367),
        _hoisted_368,
        _hoisted_369
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-conditions",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "lg",
      "modal-class": "modal-conditions",
      title: " "
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _hoisted_370
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_modal, {
      id: "comunications-policies-modal",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "lg",
      "modal-class": "modal-conditions",
      title: "Política de Comunicaciones",
      ref: "comunications-policies-modal"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_371, [
              _hoisted_372,
              _createElementVNode("div", _hoisted_373, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  id: "chkbxPolicies1",
                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.comunicationPolicies.profile) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.comunicationPolicies.profile]
                ]),
                _hoisted_374
              ]),
              _createElementVNode("div", _hoisted_375, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  id: "chkbxPolicies2",
                  "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.comunicationPolicies.offers) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.comunicationPolicies.offers]
                ]),
                _hoisted_376
              ]),
              _createElementVNode("div", _hoisted_377, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  class: "custom-control-input",
                  id: "chkbxPolicies3",
                  checked: _ctx.comunicationPolicies.profile && _ctx.comunicationPolicies.offers
              ,
                  "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.comunicationPolicies.all) = $event)),
                  onChange: _cache[55] || (_cache[55] = ($event: any) => (_ctx.changeComunicationPolicyContiion()))
                }, null, 40, _hoisted_378), [
                  [_vModelCheckbox, _ctx.comunicationPolicies.all]
                ]),
                _hoisted_379
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-terms",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "lg",
      title: "Declaración jurada del contratante"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _hoisted_380,
            _hoisted_381,
            _hoisted_382
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_modal, {
      id: "modal-policies",
      "ok-only": "",
      "ok-title": "Cerrar",
      centered: "",
      size: "lg",
      title: "POLÍTICA DE PRIVACIDAD"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_card_text, null, {
          default: _withCtx(() => [
            _hoisted_383,
            _hoisted_384,
            _hoisted_385
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_modal, {
      id: "modal-login",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "sm",
      "modal-class": "modal-login",
      title: "Inicia sesión"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_386, [
          (!_ctx.flags.validateOtp)
            ? (_openBlock(), _createElementBlock("form", _hoisted_387, [
                _createElementVNode("div", _hoisted_388, [
                  _createElementVNode("div", _hoisted_389, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "loginDni",
                      name: "client-doc",
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((this.v$.login.identificationType.$model) = $event)),
                      checked: ""
                    }, null, 512), [
                      [_vModelRadio, this.v$.login.identificationType.$model]
                    ]),
                    _hoisted_390
                  ]),
                  _createElementVNode("div", _hoisted_391, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      name: "client-doc",
                      id: "loginCe",
                      "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((this.v$.login.identificationType.$model) = $event))
                    }, null, 512), [
                      [_vModelRadio, this.v$.login.identificationType.$model]
                    ]),
                    _hoisted_392
                  ])
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-group d-block", { invalid: this.v$.login.identificationNumber.$error }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Digita tu número de documento",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((this.v$.login.identificationNumber.$model) = $event))
                  }, null, 512), [
                    [_vModelText, this.v$.login.identificationNumber.$model]
                  ]),
                  (this.v$.login.identificationNumber.$error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_393, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ error: this.v$.login.identificationNumber.$error })
                        }, "Ingrese un número de documento válido", 2)
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_394, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "form-btn",
                    onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.sendOtp())),
                    disabled: _ctx.flags.logingIn
                  }, [
                    (!_ctx.flags.logingIn)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_396, "Continuar"))
                      : _createCommentVNode("", true),
                    (_ctx.flags.logingIn)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_397))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_395)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.flags.validateOtp)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                action: "#",
                onSubmit: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.validateOtp && _ctx.validateOtp(...args)))
              }, [
                _createElementVNode("div", _hoisted_398, [
                  _createElementVNode("label", _hoisted_399, "Ingresa el código enviado al correo " + _toDisplayString(_ctx.otp.email), 1)
                ]),
                _createElementVNode("div", {
                  class: _normalizeClass(["form-group d-block", { invalid: this.v$.login.identificationNumber.$error }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    placeholder: "Codigo de autenticación",
                    class: "form-control",
                    "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((this.v$.otpCode.code.$model) = $event))
                  }, null, 512), [
                    [_vModelText, this.v$.otpCode.code.$model]
                  ]),
                  (this.v$.userInfo.identificationNumber.$error && _ctx.flags.showError
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_400, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ error: this.v$.login.identificationNumber.$error })
                        }, "Ingrese un código válido", 2)
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                _createElementVNode("div", _hoisted_401, [
                  _createElementVNode("button", {
                    type: "submit",
                    class: "form-btn",
                    disabled: _ctx.flags.logingIn
                  }, [
                    (!_ctx.flags.logingIn)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_403, "Validar"))
                      : _createCommentVNode("", true),
                    (_ctx.flags.logingIn)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_404))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_402)
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_b_modal, {
      id: "modal-quote",
      "ok-only": "",
      "ok-title": "Entendido",
      centered: "",
      size: "sm",
      "modal-class": "modal-login",
      title: "Enviar cotización",
      ref: "modal-quote"
    }, {
      default: _withCtx(() => [
        _createElementVNode("form", _hoisted_405, [
          _createElementVNode("div", {
            class: _normalizeClass(["form-group", {
          invalid: this.v$.quote.email.$error,
        }])
          }, [
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Ingrese su Email",
              "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((this.v$.quote.email.$model) = $event))
            }, null, 512), [
              [_vModelText, this.v$.quote.email.$model]
            ]),
            _hoisted_406
          ], 2),
          _createElementVNode("div", _hoisted_407, [
            _createElementVNode("button", {
              class: "btn btn-pink",
              onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.sendQuote())),
              type: "button",
              disabled: _ctx.flags.sendingQuote
            }, [
              (!_ctx.flags.sendingQuote)
                ? (_openBlock(), _createElementBlock("span", _hoisted_409, "Enviar cotización"))
                : _createCommentVNode("", true),
              (_ctx.flags.sendingQuote)
                ? (_openBlock(), _createElementBlock("i", _hoisted_410))
                : _createCommentVNode("", true)
            ], 8, _hoisted_408)
          ]),
          (this.flags.sendedQuote)
            ? (_openBlock(), _createElementBlock("p", _hoisted_411, " Cotización enviada, por favor revisa tu correo. "))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-error",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      "modal-class": "modal-error",
      ref: "modal-card-error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_412, [
          _hoisted_413,
          _createElementVNode("div", _hoisted_414, [
            _createElementVNode("img", {
              src: require('@/assets/images/app/error.svg'),
              alt: ""
            }, null, 8, _hoisted_415)
          ])
        ]),
        _createElementVNode("div", _hoisted_416, [
          _hoisted_417,
          _createElementVNode("div", _hoisted_418, [
            _createElementVNode("button", {
              type: "button",
              class: "accept",
              onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.closeModal('modal-card-error')))
            }, " Entendido ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-error",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      "modal-class": "modal-error",
      ref: "modal-error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_419, [
          _hoisted_420,
          _createElementVNode("div", _hoisted_421, [
            _createElementVNode("img", {
              src: require('@/assets/images/app/error.svg'),
              alt: ""
            }, null, 8, _hoisted_422)
          ])
        ]),
        _createElementVNode("div", _hoisted_423, [
          (_ctx.errors.payment === '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_424, " Se ha presentado un error en nuestro sistema. Intenta nuevamente o escríbenos a correo rumbo@interseguro.com.pe "))
            : _createCommentVNode("", true),
          (_ctx.errors.payment !== '')
            ? (_openBlock(), _createElementBlock("span", _hoisted_425, _toDisplayString(_ctx.errors.payment), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_426, [
            _createElementVNode("button", {
              type: "button",
              class: "accept",
              onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.closeModal('modal-error')))
            }, " Entendido ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-error",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      "modal-class": "modal-error",
      ref: "modal-error-client"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_427, [
          _hoisted_428,
          _createElementVNode("div", _hoisted_429, [
            _createElementVNode("img", {
              src: require('@/assets/images/app/error.svg'),
              alt: ""
            }, null, 8, _hoisted_430)
          ])
        ]),
        _createElementVNode("div", _hoisted_431, [
          _createElementVNode("span", null, " Se ha presentado un error en nuestro sistema. " + _toDisplayString(_ctx.modalErrorClient), 1),
          _createElementVNode("div", _hoisted_432, [
            _createElementVNode("button", {
              type: "button",
              class: "accept",
              onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.closeModal('modal-error-client')))
            }, " Entendido ")
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_b_modal, {
      id: "modal-free-month",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      size: "lg",
      "modal-class": "modal-free-month",
      ref: "modal-free-month"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_433, [
          _createTextVNode(" ¡Este "),
          _createElementVNode("img", {
            src: require('@/assets/images/app/gift.svg'),
            alt: ""
          }, null, 8, _hoisted_434),
          _createTextVNode(" espera por ti! ")
        ]),
        _createElementVNode("div", _hoisted_435, [
          _createElementVNode("div", _hoisted_436, [
            _createElementVNode("div", _hoisted_437, _toDisplayString(_ctx.hours), 1),
            _hoisted_438
          ]),
          _createElementVNode("div", _hoisted_439, [
            _createElementVNode("div", _hoisted_440, _toDisplayString(_ctx.minutes), 1),
            _hoisted_441
          ]),
          _createElementVNode("div", _hoisted_442, [
            _createElementVNode("div", _hoisted_443, _toDisplayString(_ctx.seconds < 10 ? "0" + _ctx.seconds : _ctx.seconds), 1),
            _hoisted_444
          ])
        ]),
        _createElementVNode("div", _hoisted_445, [
          _createElementVNode("div", _hoisted_446, [
            _createElementVNode("div", _hoisted_447, [
              _createElementVNode("div", _hoisted_448, [
                _createElementVNode("div", _hoisted_449, [
                  _createElementVNode("img", {
                    src: require('../../../src/assets/images/app/Group-2339.png')
                    ,
                    alt: ""
                  }, null, 8, _hoisted_450)
                ])
              ]),
              _hoisted_451
            ])
          ]),
          _createElementVNode("a", {
            href: 'https://wa.link/o1y194?utm_source=botmaker&utm_medium=whatsapp&utm_campaign=promocion_rumbo-botmaker-whatsapp-pf-on-rumbo-ahorro',
            target: "_blank",
            class: "bullets"
          }, [
            _hoisted_453,
            _createElementVNode("div", _hoisted_454, [
              _createElementVNode("ul", null, [
                _hoisted_455,
                _hoisted_456,
                _createElementVNode("li", _hoisted_457, [
                  _hoisted_458,
                  _createElementVNode("p", null, [
                    _createTextVNode(" Envíanos un pantallazo de la operación y tu N° de DNI "),
                    _hoisted_459,
                    _createTextVNode("a nuestro WhatsApp. "),
                    _createElementVNode("img", {
                      src: require('@/assets/images/app/wapp-chat.svg'),
                      alt: ""
                    }, null, 8, _hoisted_460)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_461, [
                _createElementVNode("img", {
                  src: require('../../../src/assets/images/app/mano-cel.png'),
                  alt: ""
                }, null, 8, _hoisted_462)
              ])
            ])
          ], 8, _hoisted_452),
          _hoisted_463,
          _createElementVNode("div", _hoisted_464, [
            _createElementVNode("button", {
              class: "btn btn-pink",
              onClick: _cache[67] || (_cache[67] = 
//@ts-ignore
(...args) => (_ctx.closeFreeMonthModal && _ctx.closeFreeMonthModal(...args)))
            }, " Continuar ")
          ])
        ])
      ]),
      _: 1
    }, 512)
  ]))
}